import { SRGBColorSpace, MirroredRepeatWrapping, FrontSide } from 'three';

export const pinewoodFrameMat = {
  bumpMap: 'bumpMapFrame',
  bumpScale: 0.001,
  colorSpace: SRGBColorSpace, // NoColorSpace
  name: 'pinewood_frame',
  wrap: MirroredRepeatWrapping,
  roughnessMap: 'roughnessMapFrame',
  side: FrontSide,
  uvScale: {
    u: 2,
    v: 2,
  },
};

export const pinewoodBodyMat = {
  aoMap: 'aoMapBody',
  aoMapIntensity: 1,
  bumpMap: 'bumpMapBody',
  bumpScale: 0.002,
  colorSpace: SRGBColorSpace,
  wrap: MirroredRepeatWrapping,
  name: 'pinewood_body',
  normalMap: 'normalMapBody',
  normalScale: {
    x: 3,
    y: 3,
  },
  roughnessMap: 'roughnessMapBody',
  side: FrontSide,
  uvScale: {
    u: 2.8,
    v: 2.8,
  },
};

export const metalMat = {
  aoMapIntensity: 0.1,
  color: 0x0e0e10,
  emissive: 0x000000,
  emissiveIntensity: 0.001,
  metalness: 0.4,
  name: 'metal',
  roughness: 0.7,
  // roughnessMap: 'metalRoughness',
};

export const ashwoodMat = {
  // bumpMap: 'ashBump',
  // bumpScale: 1,
  colorSpace: SRGBColorSpace,
  name: 'ashwood_body',
  roughnessMap: 'ashRoughness',
  side: FrontSide,
  uvScale: {
    u: 2,
    v: 2,
  },
};

export const foressoMat = {
  colorSpace: SRGBColorSpace,
  name: 'foresso',
  side: FrontSide,
  uvScale: {
    u: 3,
    v: 3,
  },
};

export const rattanMat = {
  alphaMap: 'rattanOpacity',
  aoMap: 'rattanAO',
  bumpMap: 'rattanBump',
  // bumpScale: 1,
  colorSpace: SRGBColorSpace,
  name: 'rattan',
  map: 'rattanMap',
  normalMap: 'rattanNormal',
  roughnessMap: 'rattanRoughness',
  side: FrontSide,
  transparent: true,
  uvScale: {
    u: 6,
    v: 6,
  },
};

export const transparentGlassMat = {
  clearcoat: 1,
  clearcoatRoughness: 0.1,
  name: 'transparent_glass',
  roughness: 0.01,
  side: FrontSide,
  thickness: 0.5, // Add refraction!
  transmission: 1,
};

export const milkyGlassMat = {
  clearcoat: 1,
  clearcoatRoughness: 0.1,
  // color: '#ffffff',
  name: 'milky_glass',
  roughness: 0.3,
  side: FrontSide,
  thickness: 0.5, // Add refraction!
  transmission: 0.8,
};

export const securityGlassMat = {
  clearcoat: 1,
  clearcoatRoughness: 0.1,
  colorSpace: SRGBColorSpace,
  map: 'wiredGlassMap',
  name: 'security_glass',
  roughness: 0.3,
  side: FrontSide,
  thickness: 0.5, // Add refraction!
  transmission: 0.8,
  uvScale: {
    u: 3,
    v: 3,
  },
};

export const mirrorGlassMat = {
  clearcoat: 1,
  clearcoatRoughness: 0.1,
  color: 0xd3d3d3,
  name: 'mirror_glass',
  // opacity: 0.25,
  // roughness: 0,
  // reflectivity: 0.5,
  side: FrontSide,
};

export const getRGBFromRAL = (ralColor) => {
  const rals = {
    white: 0xf0efe9,
    black: 0x0e0e10,
    ral1001: 0xd0b084,
    ral1005: 0xcb8e00,
    ral1018: 0xfaca30,
    ral2003: 0xf67828,
    ncs3010: 0xb7b9a6,
    ral3014: 0xf2838f,
    ral3015: 0xd8a0a6,
    ral5001: 0x0f4c64,
    ral5024: 0x6093ac,
    ral6005: 0x114232,
    ral6017: 0x587f40,
    ral6033: 0x46877f,
    ral7003: 0x7a7669,
    ral7004: 0x9b9b9b,
    ral7016: 0x383e42,
    ral9001: 0xe9e0d2,
    ral9003: 0xecece7,
    ral9005: 0x0e0e10,
    ral9010: 0xfcfaf5,
    ralcustom: 0xf56fa1,
    ral2012: 0xd5655d,
    ral5019: 0x005e83,
    ral6019: 0xb9ceac,
    ral7045: 0x8d9295,
    ral3005: 0x59191f,
    ral5003: 0x1f3855,
    ral6011: 0x6c7c59,
    ral7024: 0x45494e,
    ral7032: 0xb5b0a1,
  };
  return rals[ralColor];
};
